"use strict";
import { constants } from "./constants";
import { chain } from "../../vendor/lodash";

function Utils() {}

Utils.getQueryStringMap = (queryString) => {
  var query = (queryString || self.location.search).substring(1); // delete ?

  if (!query) {
    return false;
  }

  return chain(query.split("&"))
    .map(function (params) {
      var p = params.split("=");
      return [p[0], decodeURIComponent(p[1])];
    })
    .fromPairs()
    .value();
};
Utils.parseQueryStringForRedirectTo = () => {
  if (Utils.getQueryStringMap()[constants.redirectTo]) {
    const redirectTo = Utils.getQueryStringMap()[constants.redirectTo];
    //store in the session just so
    sessionStorage.setItem(constants.redirectTo, redirectTo);
  }
};

Utils.getRedirectPage = () => {
  Utils.parseQueryStringForRedirectTo();
  let redirectTo = sessionStorage.getItem(constants.redirectTo);
  redirectTo = redirectTo ? redirectTo : "./express.html"; // By default navigating to express.
  return redirectTo;
};

Utils.findConfigByClientId = (openIdConfigs, clientId) => {
  return openIdConfigs.find((config) => config.clientId === clientId);
};

Utils.getCookieVal = (cookiName) => {
  return window.document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${cookiName}=`))
    .split("=")[1];
};

export default Utils;
